import { DefaultLayout } from '@/layouts';
import Box from '@mui/material/Box';
import { TemplateBuilder } from '@/components/TemplateBuilder';
import { PageLoader } from '@/components/shared/PageLoader';
import UnauthorizedAccess from '@/components/UnauthorizedAccess';
import { useFetchCookies, useHavePermission } from '@/hooks';
import { Permissions } from '@/types';

export const TemplateBuilderViewPage = () => {
  const cookiesFetched = useFetchCookies();
  const canManageTemplate = useHavePermission(Permissions.MANAGE_TEMPLATE);

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <DefaultLayout>
      {canManageTemplate ? <TemplateBuilder /> : <UnauthorizedAccess />}
    </DefaultLayout>
  );
};
